const RACES = {
    HUMAN: {
        ID: 'HUMAN',
        name: 'Human',
        avatar: { male: '👨', female: '👩' },
        stats: {
            hp: 100, attack: 40, defense: 30, rate: 50,
        },
    },
    ELF: {
        ID: 'ELF',
        name: 'Elf',
        avatar: { male: '🧝‍♂️', female: '🧝‍♀️' },
        stats: {
            hp: 80, attack: 35, defense: 20, rate: 35,
        },
    },
    FAIRY: {
        ID: 'FAIRY',
        name: 'Fairy',
        avatar: {
            male: '🧚‍♂️', female: '🧚‍♀️',
        },
        stats: {
            hp: 60, attack: 25, defense: 10, rate: 25,
        },
    },
    ORC: {
        ID: 'ORC',
        name: 'Orc',
        avatar: { male: '👹', female: '👹' },
        stats: {
            hp: 140, attack: 30, defense: 30, rate: 50,
        },
    },
    GOBLIN: {
        ID: 'GOBLIN',
        name: 'Goblin',
        avatar: { male: '👺', female: '👺' },
        stats: {
            hp: 60, attack: 30, defense: 10, rate: 35,
        },
    },
    GHOST: {
        ID: 'GHOST',
        name: 'Ghost',
        avatar: {
            male: '👻', female: '👻',
        },
        stats: {
            hp: 30, attack: 20, defense: 80, rate: 60,
        },
        status: {
            undead: true,
        },
    },
    SKELETON: {
        ID: 'SKELETON',
        name: 'Skeleton',
        avatar: {
            male: '☠️', female: '💀',
        },
        stats: {
            hp: 80, attack: 15, defense: 15, rate: 40,
        },
        status: {
            undead: true,
        },
    },
    DRAGON: {
        ID: 'DRAGON',
        name: 'Skeleton',
        avatar: {
            male: '🐲', female: '🐲',
        },
        stats: {
            hp: 1200, attack: 80, defense: 60, rate: 120,
        },
    },
    VAMPIRE: {
        ID: 'VAMPIRE',
        name: 'Vampire',
        avatar: {
            male: '🧛‍♂️', female: '🧛‍♀️',
        },
        stats: {
            hp: 250, attack: 40, defense: 25, rate: 80,
        },
        status: {
            undead: true,
        },
    },
    GENIE: {
        ID: 'GENIE',
        name: 'Genie',
        avatar: {
            male: '🧞‍♂️', female: '🧞‍♀️',
        },
        stats: {
            hp: 120, attack: 50, defense: 10, rate: 70,
        },
    },
    ZOMBIE: {
        ID: 'ZOMBIE',
        name: 'Zombie',
        avatar: {
            male: '🧟‍♂️', female: '🧟‍♀️',
        },
        stats: {
            hp: 140, attack: 30, defense: 50, rate: 120,
        },
    },
    status: {
        undead: true,
    },
}

export default RACES
